import React from "react";
import Menu from "@mui/material/Menu";

interface CustomMenuProps {
  menuItems: React.ReactNode;
  openMenu: boolean;
  handleClose: () => void;
  anchorEl: null | HTMLElement;
}

const CustomMenu = ({ menuItems, openMenu, handleClose, anchorEl } : CustomMenuProps) => {
  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={openMenu}
      onClick={(e) => e.stopPropagation()}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      disableScrollLock={true}
    >
      <span>{menuItems}</span>
    </Menu>
  );
};

export default CustomMenu;
